module.exports = __webpack_public_path__ + "img/howard_amy.c8774334.png";